import { Box, Stack, Tab, Tabs as MuiTabs } from "@mui/material";
import type { ReactNode } from "react";
import type { LoyaltyTabId } from "Components/Loyalty/Shared/Tabs/config";

export type TabItem = {
  id: LoyaltyTabId;
  label: string;
  content: ReactNode;
};

type Props = {
  initialTab: LoyaltyTabId | null;
  onTabChange: (activeTab: LoyaltyTabId) => void;
  tabs: Array<TabItem>;
};

export const Tabs = ({ initialTab, onTabChange, tabs }: Props) => {
  const activeTab = initialTab || tabs[0]?.id || null;

  return (
    <Stack gap={5}>
      <MuiTabs
        value={activeTab}
        onChange={(_, id: LoyaltyTabId) => onTabChange(id)}
        variant="fullWidth"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTabs-indicator": {
            backgroundColor: "primary.main",
          },
        }}
      >
        {tabs.map(({ label, id }) => (
          <Tab label={label} value={id} key={id} />
        ))}
      </MuiTabs>
      <Box component="section">
        {tabs.map(({ content, id }) => (
          <div role="tabpanel" hidden={id !== activeTab} key={id}>
            {id === activeTab && content}
          </div>
        ))}
      </Box>
    </Stack>
  );
};
